const companySysConfigList = state =>
  state?.CompanySystemConfig?.getCompanyListForSysConfig

const CompanySelectors = {
  companySysConfigList,
}

export default CompanySelectors
